import React, { useState } from 'react';

const DropdownMenu = ({ user, onLogout, onProfileModal }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleProfileModal = () => {
        setIsOpen(false);
        onProfileModal();
    };

    return (
        <div className="dropdown-container">
            <img
                src={user}
                alt="User"
                width={50}
                height={50}
                className="user-image"
                onClick={toggleDropdown}
            />
            {isOpen && (
                <div className="dropdown-menu">
                    <button className="dropdown-item" onClick={handleProfileModal}>Profile</button>
                    <button className="dropdown-item" onClick={onLogout}>Logout</button>
                </div>
            )}
        </div>
    );
};

export default DropdownMenu;
